module.exports = __webpack_public_path__ + "static/media/strawberry.febca621.png";